import React, { useEffect, useState } from 'react'
import getFiles from '../../../../../api/preview/edit/getHistoryPreview'

import CreatableSelect from 'react-select/creatable'

import styled from 'styled-components'

const CLASS_PREFIX = `ListAsync--styledMulitSelectCreatable`

interface FileHistory {
    time: number
    sheetIndex: string
    uid: string
    fileName: string
    collection: string
    valid: boolean
}
export default function BaseListFiles({
    onChange,
    select,
    collection,
    label,
    getFilesHitory,
    isClearable = false
}: {
    onChange: (file: FileHistory) => void
    select: FileHistory
    collection: string
    label: string
    getFilesHitory: () => Promise<FileHistory[]>
    isClearable?: boolean
}) {
    const [files, setFiles] = useState<FileHistory[]>([])
    const [loading, setStateLoading] = useState<boolean>(true)
    const formatDecimal = (str: string) => {
        if (str.length == 1) return `0${str}`
        return str
    }

    useEffect(() => {
        if (!loading) setStateLoading(true)
        getFilesHitory()
            .then(data => {
                if (!Array.isArray(data)) {
                    return
                }
                setFiles(data)
                if (data?.length > 0 && !isClearable) onChange(data[data.length - 1])
            })
            .finally(() => setStateLoading(false))
    }, [collection])
    const getLabel = (file: FileHistory): string => {
        if (!file) return ''
        const date = new Date(file.time)

        return `${file.fileName} - ${date.toLocaleDateString()} ${formatDecimal(
            String(date.getHours())
        )}:${formatDecimal(String(date.getMinutes()))}`
    }
    return (
        <div style={{ width: '100%' }}>
            <label>{label}</label>
            <div style={{ minWidth: '200px' }}>
                <StyledCreatable
                    isClearable={isClearable}
                    isLoading={loading}
                    onMenuOpen={() => []}
                    isDisabled={false}
                    value={{ label: getLabel(select), value: select?.uid }}
                    onChange={event => {
                        const value = event?.value
                        if (!value) {
                            onChange(undefined)
                        } else {
                            const fileState = files.find(({ uid }) => uid === value)
                            if (select == undefined || fileState.uid !== select?.uid) {
                                onChange(fileState)
                            }
                        }
                    }}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    placeholder="files"
                    maxMenuHeight={150}
                    stye={{
                        width: '300px'
                    }}
                    options={files.map(file => ({ label: getLabel(file), value: file.uid }))}
                />
            </div>
        </div>
    )
}

const StyledCreatable = styled(CreatableSelect)`
    border: 1px solid transparent;
    &:focus-within {
        border-width: 2px;
        border-color: ${({ theme }) => theme['blue-500']};
    }

    [class$='-control'] {
        background-color: var(--gray-100);
    }

    [class$='-menu'] {
        background-color: var(--gray-0);
    }
    [class$='-singleValue'] {
        color: var(--gray-700);
    }
    [class$='-option'] {
        color: var(--gray-700);
        background-color: var(--gray-100);
    }

    .${CLASS_PREFIX}__option {
        color: ${props => props.theme['blue-500']};
        &--is-selected {
            color: ${props => props.theme['gray-0']};
        }
    }
    .${CLASS_PREFIX}__control {
        border: none;
        background-color: var(--gray-0);
        height: 20px;
        max-height: 20px;
        overflow: auto;
        border-radius: 0px;

        &::-webkit-scrollbar {
            width: 14px;
        }

        &::-webkit-scrollbar-thumb {
            background: ${({ theme }) => theme['gray-600']};
            border-radius: 25px;
            border: 4px solid transparent;
            background-clip: padding-box;
        }
    }
    .${CLASS_PREFIX}__indicator-separator {
        display: none;
    }
    .${CLASS_PREFIX}__indicators {
        display: flex;
    }
`

export { FileHistory }
